import { useEffect } from "react";

function TextSpeech({ text }) {
	let synth = null;

	if (typeof window !== "undefined") {
		synth = window.speechSynthesis;
	}

	useEffect(() => {
		speak(text);
	}, [text]);

	function speak(text) {
		if (synth.speaking) {
			console.error("speechSynthesis.speaking");
			return;
		}

		console.log(text);

		if (text !== "") {
			const utterThis = new SpeechSynthesisUtterance(text);
			utterThis.onend = function (event) {
				console.log("SpeechSynthesisUtterance.onend");
			};
			utterThis.onerror = function (event) {
				console.error("SpeechSynthesisUtterance.onerror");
			};

			console.log(synth.getVoices());
			utterThis.voice = synth.getVoices()[0];
			utterThis.pitch = 1;
			utterThis.rate = 0.9;
			synth.speak(utterThis);
		}
	}

	return (
		<div className="w-full p-10">
			<div className="w-full font-bold text-8xl flex justify-center items-center text-blue-800">
				{text}
			</div>
		</div>
	);
}

TextSpeech.defaultProps = {
	text: "test",
};

export default TextSpeech;
